// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tJmHX","newExpiryDate":"styles_newExpiryDate__3YssB","footer":"styles_footer__3q3Em"};